// Middleware
import GuestMiddleware from '@middleware/GuestMiddleware';

// Layouts
import LayoutDefault from '@layouts/LayoutDefault';

export default {
    path: '/',
    component: LayoutDefault,
    children: [
        {
            path: '',
            name: 'home',
            component: () => import('@pages/index/PageHome'),
            meta: {
                middleware: GuestMiddleware,
            },
        },
        {
            path: 'agencies',
            name: 'agencies',
            component: () => import('@pages/index/PageAgencies'),
            meta: {
                title: 'titles.agencies',
            },
        },
        {
            path: 'pricing',
            name: 'pricing',
            component: () => import('@pages/index/PagePricing'),
            meta: {
                title: 'titles.pricing',
            },
        },
        {
            path: 'contact',
            name: 'contact',
            component: () => import('@pages/index/PageContact'),
            meta: {
                title: 'titles.contact_us',
            },
        },

        {
            path: 'ltd',
            name: 'ltd',
            component: () => import('@pages/index/PageLtd'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.lifetime_deal',
            },
        },
    ],
};